export const DEFAULT_VARIANT = "outlined";
export const DEFAULT_COLOR = "gray";
export const DEFAULT_SIZE = "medium";
